import { ReactNode } from 'react';

export default function FullWidthPanel({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="w-full">
      <div className="mx-0 lg:mx-0">{children}</div>
    </div>
  );
}
